{
  "version": 1,
  "asset_id": "053a0446-552a-4232-97a3-b7146b33bff8",
  "project_id": "4dbb42ac-931e-41e9-ac57-3f509e458f26",
  "url": "/__l5e/assets-v1/053a0446-552a-4232-97a3-b7146b33bff8/property-tour.jpg",
  "r2_key": "a/v1/4dbb42ac-931e-41e9-ac57-3f509e458f26/053a0446-552a-4232-97a3-b7146b33bff8/property-tour.jpg",
  "original_filename": "property-tour.jpg",
  "size": 1349260,
  "content_type": "image/jpeg",
  "created_at": "2026-09-11T17:51:28Z"
}
